var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-tray-block container my-3" }, [
    _c("h5", { staticClass: "share-tray-header text-center " }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["virtualtray.Sharetray.Header"]) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "wf-modal-button-close btn button-full",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.hideModal("share-tray")
          }
        }
      },
      [
        _c("span", {
          staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
          attrs: { "aria-label": "Close modal" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "my-3" },
      [
        _c("label", { attrs: { for: "sharable_link" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$resourceString["common.Sharetray.Link.Label"]) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.trayUrl,
                expression: "trayUrl"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "sharable_link",
              "aria-describedby": "basic-addon3",
              disabled: ""
            },
            domProps: { value: _vm.trayUrl },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.trayUrl = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "invite_people" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$resourceString["virtualtray.Sharetray.Email.Label"]) +
              "*\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mb-2 d-flex justify-content-between align-items-center"
          },
          [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newEmail,
                    expression: "newEmail"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "invite_people",
                  placeholder: "Enter email(s)"
                },
                domProps: { value: _vm.newEmail },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addEmail($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append input-container" }, [
                _c(
                  "button",
                  {
                    staticClass: " btn-primary small-button ",
                    class: _vm.newEmail.length <= 0 ? "disabled" : "",
                    attrs: { disabled: _vm.newEmail.length == 0 },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addEmail($event)
                      }
                    }
                  },
                  [_vm._v("+\n\n        ")]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.emails, function(email, index) {
          return _c(
            "div",
            { key: index, staticClass: "wf-current-refinements-group" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-white shadow-sm mx-1 my-1 bg-dark text-light text-transform-none"
                },
                [
                  _vm._v("\n          " + _vm._s(email) + "\n\n          "),
                  _c(
                    "span",
                    {
                      staticClass: "png-icon png-icon-icons-glyph--k-close",
                      staticStyle: { width: "10px", height: "16px" },
                      on: {
                        click: function($event) {
                          return _vm.removeEmail(index)
                        }
                      }
                    },
                    [_vm._v("×")]
                  )
                ]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c("p", { staticClass: "text-danger font-16" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.validationError.registeredEmail
                  ? _vm.$resourceString[
                      "virtualtray.Sharetray.Email.Role.Error"
                    ]
                  : _vm.validationError.invitePeople
                  ? _vm.$resourceString[
                      "virtualtray.Sharetray.Email.Required.Error"
                    ]
                  : _vm.validationError.validEmail
                  ? _vm.$resourceString[
                      "virtualtray.Sharetray.Email.ValidEmail.Error"
                    ]
                  : ""
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "email_subject" } }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$resourceString["virtualtray.Sharetray.Subject.Label"]
              ) +
              "*\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: " mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailSubject,
                expression: "emailSubject"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "email_subject",
              placeholder: "Email Subject"
            },
            domProps: { value: _vm.emailSubject },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.emailSubject = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.validationError.emailSubject
            ? _c("p", { staticClass: "text-danger font-16" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.Sharetray.Subject.Error"]
                    ) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "tray-description" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$resourceString["common.Sharetray.EmailNote.Label"]) +
              " " +
              _vm._s(
                _vm.$resourceString["contentWizard.Label.Field.Optional"]
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group mb-4" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailNote,
                expression: "emailNote"
              }
            ],
            staticClass: "form-control",
            attrs: {
              id: "tray-description",
              "aria-label": "With textarea",
              placeholder: "Email Note..."
            },
            domProps: { value: _vm.emailNote },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.emailNote = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-2 float-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-primary",
              on: { click: _vm.handleModalClose }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: { click: _vm.shareTrayItem }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Sharetray.Share.Button"]
                  ) +
                  "\n      "
              )
            ]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }